module.exports = __webpack_public_path__ + "img/authentication-bg.3dfd56b6.svg";